const formatPrice = (value: number): string | null => {
  if (!value) { return null }
  if (value < 1) {
    const str = value.toString();
    const match = str.match(/0\.0*/);
    const leadingZeros = match ? match[0].length - 2 : 0;
    return `$${value.toFixed(leadingZeros + 4)}`;
  }
  return `$${value.toFixed(2)}`;
}

const formatPercentage = (value: number): string | null => {
  if (!value) { return null }
  if (value < 0.01) {
    const str = value.toString();
    const match = str.match(/0\.0*/);
    const leadingZeros = match ? match[0].length - 2 : 0;
    return `${value.toFixed(leadingZeros + 2)}%`;
  }
  return `${value.toFixed(2)}%`;
}

const formatLargeNumber = (value: number): string => {
  if (value >= 1e12) {
    return `$${(value / 1e12).toFixed(2)}T`;
  }
  if (value >= 1e9) {
    return `$${(value / 1e9).toFixed(2)}B`;
  }
  if (value >= 1e6) {
    return `$${(value / 1e6).toFixed(2)}M`;
  }
  if (value >= 1e3) {
    return `$${(value / 1e3).toFixed(2)}K`;
  }
  return `$${value.toFixed(2)}`;
}

const millionsPriceFormatter = (price: number) => `$${(price / 1000000).toFixed(2)}m`
const billionsPriceFormatter = (price: number) => `$${(price / 1000000000).toFixed(2)}b`
const percentFormatter = (price: number) => `${price.toFixed(2)}%`
const bitcoinPriceFormatter = (price: number) => `₿${price.toFixed(2)}`
const ethereumPriceFormatter = (price: number) => `Ξ${price.toFixed(2)}`
// round and 2nd decimal then format by millions $
const flowPrice = (price:number) => millionsPriceFormatter(Math.round(price * 100) / 100)

export const numberFormatters = {
  price: millionsPriceFormatter,
  percent: percentFormatter,
  largeNumber: billionsPriceFormatter,
  flowPrice: flowPrice,
  bitcoinPrice: bitcoinPriceFormatter,
  ethereumPrice: ethereumPriceFormatter
}